import { Component } from '@angular/core';

@Component({
  selector: 'app-about-us',
  template: `
  <p>
    The Information Repository (IR) is intended to keep community neighbors, employees, and other interested parties informed
    about CERCLA or "Superfund" activities ongoing at BARC and to satisfy requirements to which both EPA and ARS have agreed.
    The Administrative Record (AR) file is created to document EPA's decision making process for a response action, addressing
    all relevant factual and policy factors for a particular site. The AR must show that EPA followed proper procedures and
    technical judgment in making a decision, and was not arbitrary. For BARC, the IR and the AR are virtually identical,
    although the IR may contain some additional background documents and materials that are not key to decision making processes.
  </p>

  <p>
    Under its agreement with EPA, ARS is required to create and maintain the AR, and make the Administrative Record file
    available to the public at a designated site repository at or near the site and the appropriate EPA Regional Office.
    This provides the public with the opportunity to review the documents and provide input on EPA's decision making process.
  </p>

  <p>
    When an Administrative Record file is created, it is intended to serve the dual purpose of defining the scope of judicial
    review for the cost recovery process and providing an opportunity for public participation in the decision making process.
    All Superfund response actions are required under CERCLA to have an Administrative Record file available for public viewing.
  </p>

  <p>
    Administrative Record files may be added to as relevant documents are generated or received by the EPA. The Administrative
    Record is not considered complete until it contains a "decision document" that signals the completion of the investigation
    or cleanup process under Superfund.   For example, for sites requiring cleanup, a "Record of Decision" (ROD) is produced
    that describes the remedy selected and its rationale.  At BARC, a "Closeout Report" is issued for those AOCs that have been
    investigated, but where no further action (NFA) is required to protect human health or the environment.   At a given site,
    there may be several removal actions and/or remedial actions known as "Operable Units" (e.g., Soils Operable Unit,
      Groundwater Operable Unit). For every removal action or operable unit, a separate Administrative Record is compiled.
  </p>

  <p>
    The Administrative Record represents EPA's official collection of documents, data, reports and other information that support
    EPA's decision on cleaning up the site. Documents listed in the Administrative Record Index may be requested through the Freedom
    of Information Act by writing to:
  </p>

  <p>
    Richard Van Holt<br />
    Freedom of Information Officer<br />
    United States Environmental Protection Agency<br />
    Region 3, 3CG10<br />
    1650 Arch Street<br />
    Philadelphia, PA 19103<br />
  </p>
  `
})
export class AboutUsComponent {}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/irar/components/about-us.ts